module.exports = __webpack_public_path__ + "static/media/mbg.7b60f9c4.png";